export default __webpack_public_path__ + "static/media/keno.725d4e3a.gif";